export const Methods = Object.freeze({
  VIEWPORT_FEATURES: 'viewportFeatures',
  VIEWPORT_FEATURES_FORMULA: 'viewportFeaturesFormula',
  VIEWPORT_FEATURES_HISTOGRAM: 'viewportFeaturesHistogram',
  VIEWPORT_FEATURES_CATEGORY: 'viewportFeaturesCategory',
  VIEWPORT_FEATURES_SCATTERPLOT: 'viewportFeaturesScatterPlot',
  LOAD_GEOJSON_FEATURES: 'loadGeoJSONFeatures',
  VIEWPORT_FEATURES_GEOJSON: 'viewportFeaturesGeoJSON'
});
